import api from '@/lib/api';
import type {
  HouseAccountWithBalance,
  HouseAccountDetail,
  HouseAccountItem,
} from './frontdeskOps.types';
import { HouseAccountItemDirection } from './frontdeskOps.types';

export interface ListHouseAccountsQuery {
  propertyId: string;
}

export interface CreateHouseAccountPayload {
  propertyId: string;
  name: string;
  description?: string | undefined;
}

export interface PostHouseAccountItemPayload {
  direction: HouseAccountItemDirection;
  /** positive amount, >= 0.01 */
  amount: number;
  description: string;
  entryDate?: string | undefined;
}

export interface PostHouseAccountItemResult {
  item: HouseAccountItem;
  /** server-authoritative running balance after the post */
  balance: number;
}

export async function fetchHouseAccounts(
  query: ListHouseAccountsQuery,
): Promise<HouseAccountWithBalance[]> {
  const { data } = await api.get<HouseAccountWithBalance[]>('/house-accounts', { params: query });
  return data;
}

export async function createHouseAccount(
  payload: CreateHouseAccountPayload,
): Promise<HouseAccountWithBalance> {
  const { data } = await api.post<HouseAccountWithBalance>('/house-accounts', payload);
  return data;
}

export async function fetchHouseAccountItems(id: string): Promise<HouseAccountDetail> {
  const { data } = await api.get<HouseAccountDetail>(`/house-accounts/${id}/items`);
  return data;
}

export async function postHouseAccountItem(
  id: string,
  payload: PostHouseAccountItemPayload,
): Promise<PostHouseAccountItemResult> {
  const { data } = await api.post<PostHouseAccountItemResult>(
    `/house-accounts/${id}/items`,
    payload,
  );
  return data;
}
